import React from "react";
import { Icon } from "@chakra-ui/react";

export function DeterministicMatchingSvg() {
  return (
    <Icon width="100%" height="auto" fill="none" viewBox="0 0 814 635">
      <g className="node-group">
        <g id="line-group-1" className="line-group">
          <path className="line" d="M108.083 436.557L383.033 546.383" stroke="#40DE9E" strokeWidth="2.25" />
          <path className="line" d="M281.419 395.988L394.116 530.13" stroke="#40DE9E" strokeWidth="2.25" />
          <path className="line" d="M109.492 405.255L219.178 374.317" stroke="#40DE9E" strokeWidth="2.25" />
        </g>
        <g id="node-1" className="node">
          <circle cx="71.4957" cy="416.197" r="42.1875" transform="rotate(-13.5186 71.4957 416.197)" fill="#2D71DC" />
          <g className="node-gradient">
            <circle
              cx="71.4959"
              cy="416.197"
              r="42.1875"
              transform="rotate(115 71.4959 416.197)"
              fill="url(#paint0_linear_11217_5935)"
            />
            <circle
              opacity="0.5"
              cx="71.4957"
              cy="416.197"
              r="42.1875"
              transform="rotate(69.7591 71.4957 416.197)"
              fill="url(#paint1_linear_11217_5935)"
            />
          </g>
        </g>
        <g id="node-2" className="node">
          <circle cx="422.312" cy="561.141" r="42.1875" transform="rotate(-160.066 422.312 561.141)" fill="#2D71DC" />
          <g className="node-gradient">
            <circle
              cx="422.312"
              cy="561.141"
              r="42.1875"
              transform="rotate(-66.1269 422.312 561.141)"
              fill="url(#paint2_linear_11217_5935)"
            />
            <circle
              opacity="0.5"
              cx="422.314"
              cy="561.139"
              r="42.1875"
              transform="rotate(-40.5927 422.314 561.139)"
              fill="url(#paint3_linear_11217_5935)"
            />
          </g>
        </g>
        <g id="node-3" className="node">
          <circle cx="256.944" cy="362.023" r="42.1875" transform="rotate(103.653 256.944 362.023)" fill="#2D71DC" />
          <g className="node-gradient">
            <circle
              opacity="0.5"
              cx="256.948"
              cy="362.023"
              r="42.1875"
              transform="rotate(166.167 256.948 362.023)"
              fill="url(#paint4_linear_11217_5935)"
            />
            <circle
              cx="256.944"
              cy="362.023"
              r="42.1875"
              transform="rotate(-121.707 256.944 362.023)"
              fill="url(#paint5_linear_11217_5935)"
            />
          </g>
        </g>
      </g>
      <g className="node-group">
        <path id="line-group-2" className="line" d="M493 176L632 82" stroke="#40DE9E" strokeWidth="2.25" />
        <g id="node-4" className="node">
          <circle cx="665.803" cy="57.6293" r="42.1875" transform="rotate(-120 665.803 57.6293)" fill="#2D71DC" />
          <circle
            className="node-gradient"
            opacity="0.6"
            cx="665.804"
            cy="57.6286"
            r="42.1875"
            transform="rotate(-120 665.804 57.6286)"
            fill="url(#paint6_linear_11217_5935)"
          />
        </g>
        <g id="node-5" className="node">
          <circle cx="457.678" cy="198.255" r="42.1875" fill="#2D71DC" />
          <circle
            className="node-gradient"
            opacity="0.6"
            cx="457.678"
            cy="198.257"
            r="42.1875"
            transform="rotate(45 457.678 198.257)"
            fill="url(#paint7_linear_11217_5935)"
          />
        </g>
      </g>
      <g className="node-group">
        <path
          id="line-group-3"
          className="line"
          d="M562.449 388.304L648.349 272.714"
          stroke="#40DE9E"
          strokeWidth="2.25"
        />
        <g id="node-6" className="node">
          <circle cx="530.242" cy="433.944" r="56.25" transform="rotate(30 530.242 433.944)" fill="#2D71DC" />
          <circle
            className="node-gradient"
            opacity="0.7"
            cx="530.241"
            cy="433.947"
            r="56.25"
            transform="rotate(30 530.241 433.947)"
            fill="url(#paint8_linear_11217_5935)"
          />
        </g>
        <g id="node-7" className="node">
          <circle cx="679.866" cy="226.945" r="56.25" transform="rotate(-150 679.866 226.945)" fill="#2D71DC" />
          <circle
            className="node-gradient"
            opacity="0.7"
            cx="679.866"
            cy="226.943"
            r="56.25"
            transform="rotate(-150 679.866 226.943)"
            fill="url(#paint9_linear_11217_5935)"
          />
        </g>
      </g>
      <circle
        id="node-8"
        className="node node-group"
        cx="264.743"
        cy="133.568"
        r="28.125"
        transform="rotate(105 264.743 133.568)"
        fill="#2D71DC"
      />
      <circle
        id="node-9"
        className="node node-group"
        cx="778.865"
        cy="381.068"
        r="28.125"
        transform="rotate(-75 778.865 381.068)"
        fill="#2D71DC"
      />
      <mask id="path-25-inside-1_11217_5935" fill="white">
        <path d="M295.816 425.929C295.816 424.824 296.711 423.929 297.816 423.929H353.816C354.92 423.929 355.816 424.824 355.816 425.929V449.929C355.816 451.034 354.92 451.929 353.816 451.929H297.816C296.711 451.929 295.816 451.034 295.816 449.929V425.929Z" />
      </mask>
      <g id="text-group">
        <path
          id="text-border"
          d="M295.816 425.929C295.816 424.824 296.711 423.929 297.816 423.929H353.816C354.92 423.929 355.816 424.824 355.816 425.929V449.929C355.816 451.034 354.92 451.929 353.816 451.929H297.816C296.711 451.929 295.816 451.034 295.816 449.929V425.929Z"
          fill="#02131B"
          stroke="#40DE9E"
          strokeWidth="4.5"
          mask="url(#path-25-inside-1_11217_5935)"
        />
        <path
          id="text"
          d="M314.125 441.929H307.538V432.399H314.125V433.824H309.122V436.477H313.333V437.85H309.122V440.503H314.125V441.929ZM316.773 441.929H315.083L318.079 438.035L315.268 434.379H317.01L318.977 436.939L320.904 434.379H322.594L319.795 437.995L322.831 441.929H321.089L318.924 439.104L316.773 441.929ZM326.228 442.18C324.604 442.18 323.588 441.309 323.588 439.936C323.588 438.589 324.538 437.771 326.413 437.494L328.894 437.137V436.913C328.894 435.963 328.261 435.408 327.192 435.408C326.136 435.408 325.41 435.976 325.225 436.953L323.746 436.398C324.195 434.933 325.462 434.115 327.244 434.115C329.198 434.115 330.346 435.105 330.346 436.794V440.187C330.346 440.886 330.399 441.467 330.518 441.929H329C328.947 441.612 328.921 441.335 328.894 440.794C328.274 441.731 327.403 442.18 326.228 442.18ZM326.518 440.952C327.904 440.952 328.894 439.962 328.894 438.589V438.299L326.664 438.642C325.581 438.801 325.08 439.183 325.08 439.857C325.08 440.556 325.621 440.952 326.518 440.952ZM335.773 442.18C333.516 442.18 331.932 440.569 331.932 438.141C331.932 435.712 333.503 434.115 335.799 434.115C337.516 434.115 338.809 435.012 339.297 436.596L337.793 437.203C337.581 436.068 336.829 435.408 335.76 435.408C334.374 435.408 333.437 436.491 333.437 438.141C333.437 439.804 334.387 440.886 335.76 440.886C336.816 440.886 337.568 440.239 337.793 439.104L339.297 439.698C338.809 441.269 337.489 442.18 335.773 442.18ZM343.463 442.18C342.209 442.18 341.509 441.361 341.509 439.989V435.619H340.295V434.379H341.509V433.177L342.975 432.042V434.379H344.493V435.619H342.975V439.909C342.975 440.569 343.212 440.899 343.687 440.899C344.004 440.899 344.321 440.741 344.493 440.503L344.796 441.731C344.532 442.008 344.031 442.18 343.463 442.18Z"
          fill="#40DE9E"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_11217_5935"
          x1="71.4959"
          y1="374.009"
          x2="71.4959"
          y2="412.259"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40DE9E" />
          <stop offset="1" stopColor="#2D71DC" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_11217_5935"
          x1="71.4957"
          y1="374.009"
          x2="71.4957"
          y2="412.259"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40DE9E" />
          <stop offset="1" stopColor="#2D71DC" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_11217_5935"
          x1="422.312"
          y1="518.953"
          x2="422.312"
          y2="557.203"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40DE9E" />
          <stop offset="1" stopColor="#2D71DC" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_11217_5935"
          x1="422.314"
          y1="518.952"
          x2="422.314"
          y2="557.202"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40DE9E" />
          <stop offset="1" stopColor="#2D71DC" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_11217_5935"
          x1="256.948"
          y1="319.835"
          x2="256.948"
          y2="358.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40DE9E" />
          <stop offset="1" stopColor="#2D71DC" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_11217_5935"
          x1="256.944"
          y1="319.835"
          x2="256.944"
          y2="358.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40DE9E" />
          <stop offset="1" stopColor="#2D71DC" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_11217_5935"
          x1="665.804"
          y1="15.4411"
          x2="665.804"
          y2="53.6911"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40DE9E" />
          <stop offset="1" stopColor="#2D71DC" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_11217_5935"
          x1="457.678"
          y1="156.07"
          x2="457.678"
          y2="194.32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40DE9E" />
          <stop offset="1" stopColor="#2D71DC" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_11217_5935"
          x1="530.241"
          y1="377.697"
          x2="530.241"
          y2="428.697"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40DE9E" />
          <stop offset="1" stopColor="#2D71DC" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_11217_5935"
          x1="679.866"
          y1="170.693"
          x2="679.866"
          y2="221.693"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40DE9E" />
          <stop offset="1" stopColor="#2D71DC" stopOpacity="0" />
        </linearGradient>
      </defs>
    </Icon>
  );
}
